/**
 * Powder PDP deal urgency — sticky timer/menu stack + louder timer offset sync.
 */
(function () {
  if (window.__powderDealUrgency) return;
  window.__powderDealUrgency = true;
  function isPowder() {
    var path = (location.pathname || "").toLowerCase();
    if (path.indexOf("hairline-shadow-powder") !== -1) return true;
    if (document.querySelector('[data-product-handle="hairline-shadow-powder-makeup"]')) return true;
    if (document.body && /hair-powder|hairline-shadow-powder/i.test(document.body.className || "")) return true;
    return !!document.querySelector('script[src*="hairline-shade-swatches"]');
  }

  function syncUrgencyStack() {
    var timer = document.getElementById("hestia-urgency-timer");
    if (!timer || timer.hidden) return;
    var h = Math.ceil(timer.getBoundingClientRect().height) || 56;
    document.documentElement.style.setProperty("--moosh-urgency-h", h + "px");
    document.documentElement.classList.add("moosh-urgency-sticky-on");
    if (document.body) document.body.classList.add("moosh-urgency-sticky-on");
  }

  function scrubInjectedDealExtras() {
    document.querySelectorAll(".qb-deal-you-save, .qb-deal-fomo").forEach(function (n) {
      n.remove();
    });
  }

  function paint() {
    if (!isPowder()) return;
    syncUrgencyStack();
    scrubInjectedDealExtras();
  }

  function bind() {
    if (!isPowder()) return;
    paint();
    window.addEventListener("resize", syncUrgencyStack, { passive: true });
    setTimeout(paint, 80);
    setTimeout(paint, 400);
    setTimeout(paint, 1200);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bind);
  } else {
    bind();
  }
  document.addEventListener("shopify:section:load", bind);
})();
